/**
 * Transient banner shown when a batch sync completes successfully after
 * the user has been offline.
 */
import { useEffect, useRef } from 'react'
import toast from 'react-hot-toast'

export default function SyncSuccessBanner() {
  const lastCountRef = useRef<number>(0)

  useEffect(() => {
    const onCompleted = (e: Event) => {
      const detail = (e as CustomEvent).detail as { success: number; conflicts: number; dead: number }
      if (!detail) return
      if (detail.success > 0 && detail.success !== lastCountRef.current) {
        lastCountRef.current = detail.success
        toast.success(
          `${detail.success} modification${detail.success > 1 ? 's' : ''} synchronisée${detail.success > 1 ? 's' : ''}`,
          { duration: 4000, icon: '✅' }
        )
      }
      if (detail.dead > 0) {
        toast.error(
          `${detail.dead} modification${detail.dead > 1 ? 's' : ''} n'ont pas pu être synchronisées. Voir /sync.`,
          { duration: 6000 }
        )
      }
    }
    window.addEventListener('offline-sync-completed', onCompleted)
    return () => window.removeEventListener('offline-sync-completed', onCompleted)
  }, [])

  return null
}
